function FilterChip({ label, isActive, onClick, count }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 border px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.12em] transition ${
        isActive
          ? "border-brand-navy bg-brand-navy text-white"
          : "border-brand-line bg-white text-brand-charcoal hover:border-brand-gold-strong/65 hover:text-brand-navy"
      }`}
    >
      <span>{label}</span>
      {typeof count === "number" ? (
        <span className={`px-1.5 py-0.5 text-[10px] ${isActive ? "bg-white/20 text-white" : "bg-brand-sky text-brand-navy"}`}>
          {count}
        </span>
      ) : null}
    </button>
  );
}

function CollegeFilters({
  stateFilters,
  pathwayFilters,
  selectedState,
  selectedPathway,
  onStateChange,
  onPathwayChange,
  stateCounts = {},
  pathwayCounts = {},
  filteredCount = 0,
  totalCount = 0,
  onReset
}) {
  return (
    <section className="border border-brand-line bg-white p-5 shadow-card sm:p-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand-charcoal/66">Archive Filters</p>
          <p className="mt-1 text-sm text-brand-charcoal/82">
            Showing <span className="font-semibold text-brand-navy">{filteredCount}</span> of{" "}
            <span className="font-semibold text-brand-navy">{totalCount}</span> colleges
          </p>
        </div>

        {(selectedState !== "all" || selectedPathway !== "all") && onReset ? (
          <button
            type="button"
            onClick={onReset}
            className="border border-brand-line bg-brand-sky/45 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.1em] text-brand-navy hover:bg-brand-sky"
          >
            Reset Filters
          </button>
        ) : null}
      </div>

      <div className="mt-5 space-y-4">
        <div>
          <p className="mb-3 border-l-2 border-brand-gold-strong pl-2.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy">
            Geographic Region
          </p>
          <div className="flex flex-wrap gap-2">
            {stateFilters.map((filter) => (
              <FilterChip
                key={filter.value}
                label={filter.label}
                count={stateCounts[filter.value]}
                isActive={selectedState === filter.value}
                onClick={() => onStateChange(filter.value)}
              />
            ))}
          </div>
        </div>

        <div>
          <p className="mb-3 border-l-2 border-brand-gold-strong pl-2.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy">
            Academic Pathway
          </p>
          <div className="flex flex-wrap gap-2">
            {pathwayFilters.map((filter) => (
              <FilterChip
                key={filter.value}
                label={filter.label}
                count={pathwayCounts[filter.value]}
                isActive={selectedPathway === filter.value}
                onClick={() => onPathwayChange(filter.value)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CollegeFilters;
